import { IconBuildingBank, IconChevronRight, IconWorld } from "@tabler/icons-react";
import type { ReactNode } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui";

/** Origen del proveedor · determina los campos y validaciones del alta. */
export type TipoProveedor = "nacional" | "extranjero";

/**
 * Modal de selección del tipo de proveedor (nacional vs extranjero). Es el
 * primer paso del alta: según la opción elegida, el formulario carga los
 * campos y validaciones correspondientes (RFC mexicano vs identificador fiscal
 * libre). Cerrar sin elegir cancela el alta.
 */
export function SeleccionarTipoProveedorModal({
  open,
  onOpenChange,
  onSeleccionar,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSeleccionar: (tipo: TipoProveedor) => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Nuevo proveedor</DialogTitle>
          <DialogDescription>¿Qué tipo de proveedor quieres registrar?</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          <OpcionTipo
            icon={<IconBuildingBank size={22} stroke={1.6} />}
            titulo="Nacional"
            descripcion="Con RFC mexicano (12-13 caracteres) y datos bancarios."
            onClick={() => onSeleccionar("nacional")}
          />
          <OpcionTipo
            icon={<IconWorld size={22} stroke={1.6} />}
            titulo="Extranjero"
            descripcion="Con identificador fiscal libre (tax ID / VAT), sin formato mexicano."
            onClick={() => onSeleccionar("extranjero")}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

function OpcionTipo({
  icon,
  titulo,
  descripcion,
  onClick,
}: {
  icon: ReactNode;
  titulo: string;
  descripcion: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="group flex flex-col gap-2 rounded-lg border border-border bg-card p-4 text-left transition-colors hover:border-multiva-600 hover:bg-multiva-600/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-multiva-600/30"
    >
      <div className="flex items-center justify-between">
        <span className="flex size-10 items-center justify-center rounded-md bg-multiva-600/10 text-multiva-600">{icon}</span>
        <IconChevronRight size={18} className="text-muted-foreground transition-transform group-hover:translate-x-0.5 group-hover:text-multiva-600" />
      </div>
      <span className="text-sm font-semibold text-foreground">{titulo}</span>
      <span className="text-xs text-muted-foreground">{descripcion}</span>
    </button>
  );
}
